<template>
  <div class="radiobox">
    <input :disabled="disabled" type="radio" v-model="value" :key="o" v-for="(opt, o) in options" :value="opt"
    :style="round?{borderRadius: '30px'}:{}">
  </div>
</template>

<script>
export default {
  props: ['options', 'defaultValue', 'round', 'disabled'],
  data () {
    return {
      value: null
    }
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('input', this.value)
      }
    }
  },
  mounted () {
    this.value = this.defaultValue
  }

}
</script>

<style lang="scss" scoped>
.radiobox {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  gap: 10px;
}
input[type=radio] {
  width: 100%;
  appearance: none;
  background-color: #C4C4C4;
  padding-inline: 21px;
  height: 50px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: 0.1em;
  &:checked {
    background-color: var(--color-checked);
  }
  &::before {
    content: attr(value);
  }
}
</style>
